// extracted by mini-css-extract-plugin
export default {"products":"Rv-z","card":"Sv-z","oosMessaging":"Tv-z"};